(() => {
  const locales = {
    it: 'it-IT',
    en: 'en-GB',
    de: 'de-DE',
    fr: 'fr-FR',
    es: 'es-ES',
  };
  const language = (document.documentElement.lang || 'it').toLowerCase().split('-')[0];
  const targetLocale = locales[language];
  const selector = 'iframe[src*="widget.trustpilot.com/trustboxes/"]';

  if (!targetLocale) return;

  const localizeFrame = (frame) => {
    const source = frame.getAttribute('src') || '';
    const currentLocale = source.match(/[?#&]locale=([^&]+)/)?.[1];

    if (!currentLocale || currentLocale === targetLocale) return;

    frame.setAttribute('src', source.replace(/([#&]locale=)[^&]+/, `$1${targetLocale}`));
  };

  const scan = (root) => {
    if (root instanceof HTMLIFrameElement && root.matches(selector)) localizeFrame(root);
    root.querySelectorAll?.(selector).forEach(localizeFrame);
  };

  scan(document);

  new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'attributes') {
        scan(record.target);
        return;
      }

      record.addedNodes.forEach(scan);
    });
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['src'],
    childList: true,
    subtree: true,
  });
})();
